import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

export const SkipErrorInterceptorHeader = 'X-Skip-Error-Interceptor';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private dialog: MatDialog,
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {

    //Skip error interceptor if header is present
    if(request.headers.has(SkipErrorInterceptorHeader)) {
      const headers = request.headers.delete(SkipErrorInterceptorHeader);
      request = request.clone({ headers });
      return next.handle(request);
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error instanceof ErrorEvent) {
          console.error('Client error', error);
        } else if (error.status !== 400) {
          this.dialog.closeAll();
          if (error.status == 404) {
            this.router.navigateByUrl('login').catch(console.error);
          } else if (error.status === 401 || error.status === 403) {
            this.router.navigateByUrl('no-permission').catch(console.error);
          }
        }
        return throwError(() => error);
      })
    );
  }
}
